import type { ApiResponse } from '~/types/ApiResponse'
import { contentTypes, type AnnouncementBannerModel } from '~/models'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'

interface AnnouncementState {
  announcementsSlider: AnnouncementBannerModel[]
  linkedItems: IContentItemsContainer | undefined
}

export const useAnnouncementStore = defineStore('announcement', {
  state: (): AnnouncementState => ({
    announcementsSlider: [],
    linkedItems: undefined
  }),
  actions: {
    async fetchData() {
      const response =
        await $fetch<
          ApiResponse<{ items: AnnouncementBannerModel[]; linkedItems: IContentItemsContainer }>
        >('/api/announcements')
      const announcements = response.data?.items ?? []
      this.announcementsSlider = announcements.filter(
        (a) =>
          !a.elements?.style?.value[0] ||
          a.elements?.style.value[0]?.codename ==
            contentTypes._announcement_banner.elements.style.options.slider.codename
      )
      this.linkedItems = response.data?.linkedItems
    }
  },
  getters: {
    getAnnouncementsSlider: (state) => (): AnnouncementBannerModel[] => {
      return state.announcementsSlider
    },
    getListAs:
      (state) =>
      <T>(codenames: string[] | undefined) => {
        if (codenames && codenames.length > 0) {
          return codenames.map((codename) => state.linkedItems?.[codename] as T).filter((x) => x)
        }
        return []
      }
  }
})
